import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  conversations: {},
  currentConversation: null,
  isChatOpened: false,
  loading: false,
};

const harmonyChatSlice = createSlice({
  name: 'harmonyChatSlice',
  initialState,
  reducers: {
    showHarmonyChat(state) {
      state.isChatOpened = true;
    },
    hideHarmonyChat(state) {
      state.isChatOpened = false;
    },
    toggleHarmonyChat(state) {
      state.isChatOpened = !state.isChatOpened;
    },
    clearHarmonyChatConversation(state) {
      state.currentConversation = null;
    },
    createHarmonyChatConversation(state) {
      state.currentConversation = null;
    },
  },
});

export const {
  showHarmonyChat,
  hideHarmonyChat,
  toggleHarmonyChat,
  clearHarmonyChatConversation,
  createHarmonyChatConversation,
} = harmonyChatSlice.actions;

export default harmonyChatSlice.reducer;
